export default "__VITE_ASSET__B$j5N2eN__"